import React from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';
const ProductFeatureBadgeWidget = (props: any) => {

  return (
    <div className="productbadge-techCard-widgte-background">
      <div className="container-fluid">
        <div className="container">
          <Row md={props.data.numberOfColumns} sm={1} xs={1}>
            {props.data.FeatureBadges.map((items: any, i: number) => {
              return (
                <Col key={i} >
                  <div className="productbadge-flex-container">
                    <img className="productfeaturebadge-img " src={API.baseUrl + items.icon?.url} alt={items.icon ? items.icon.alternativeText : ''} />
                    <h4>{items.label}</h4>
                    <h6>{items.subTitle}</h6>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ProductFeatureBadgeWidget;
